module.exports = __webpack_public_path__ + "img/tools.8993bcb2.svg";